import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../services/api";

// Async thunks
export const fetchJobBatches = createAsyncThunk(
  "jobBatches/fetchJobBatches",
  async () => {
    const response = await api.get("/job-batches/get-all-batches");
    return response.data;
  }
);

export const createJobBatch = createAsyncThunk(
  "jobBatches/createJobBatch",
  async (jobBatchData) => {
    const response = await api.post("/job-batches/create-batch", jobBatchData);
    return response.data;
  }
);

export const updateJobBatch = createAsyncThunk(
  "jobBatches/updateJobBatch",
  async ({ id, data }) => {
    const response = await api.put(`/job-batches/update-batch/${id}`, data);
    return response.data;
  }
);

export const deleteJobBatch = createAsyncThunk(
  "jobBatches/deleteJobBatch",
  async (id) => {
    await api.delete(`/job-batches/delete-batch/${id}`);
    return id;
  }
);

const initialState = {
  items: [],
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  currentJobBatch: null,
};

const jobBatchesSlice = createSlice({
  name: "jobBatches",
  initialState,
  reducers: {
    setCurrentJobBatch: (state, action) => {
      state.currentJobBatch = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearAllData: (state) => {
      state.items = [];
      state.status = "idle";
      state.error = null;
      state.currentJobBatch = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch job batches
      .addCase(fetchJobBatches.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchJobBatches.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload;
        state.error = null;
      })
      .addCase(fetchJobBatches.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      // Create job batch
      .addCase(createJobBatch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createJobBatch.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items.push(action.payload);
        state.error = null;
      })
      .addCase(createJobBatch.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      // Update job batch
      .addCase(updateJobBatch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateJobBatch.fulfilled, (state, action) => {
        state.status = "succeeded";
        const index = state.items.findIndex(
          (item) => item.id === action.payload.id
        );
        if (index !== -1) {
          state.items[index] = action.payload;
        }
        state.error = null;
      })
      .addCase(updateJobBatch.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      // Delete job batch
      .addCase(deleteJobBatch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteJobBatch.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = state.items.filter((item) => item.id !== action.payload);
        state.error = null;
      })
      .addCase(deleteJobBatch.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { setCurrentJobBatch, clearError, clearAllData } =
  jobBatchesSlice.actions;

export default jobBatchesSlice.reducer;
